import { FC, useEffect, useRef, useState } from 'react';
import './SessionsList.scss';
import images from '../../assets/images';
import { getAllSavedSessionsType, liveSessionListType, singleSessionType } from '../../pages/LiveClass/LiveClass';
import { calculateDays, calculateDuration, convertToMinutes, formatPart, formatSavedDate, formatTime, getFormattedDateInfo, getScreenDimensions, hasUserAlreadyJoined } from '../../utils/helper';
import { Menu, MenuItem, Tooltip } from '@mui/material';
import { useLazyQuery, useMutation } from '@apollo/client';
import { DELETE_SCHEDULED_SESSION, GET_SESSTION_BY_ID } from '../../pages/LiveClass/api/LiveClassQuery';
import { useAppSelector } from '../../redux/app/hooks';
import ConfirmationPopup from '../ConfirmationPopup/ConfirmationPopup';
import ToasterWithMessage from '../toaster';
import { useNavigate } from 'react-router-dom';
import { ALERT_MESSAGE_ALREADY_IN_MEETING, ALERT_MESSAGE_TWO_USERS, FETCH_POLICY_NO_CACHE, JITSI, PATH_ADDRESSES, STUDENT_ROLE, SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR, SUBJECT_NOT_FOUND_ERROR, TEACHER_ROLE } from '../../utils/constants';
import { getUserMedia } from '../../utils/webRTCHelper';
import { useGlobalState } from '../../MeetContext/MeetContext';
import WarningPopup from '../WarningPopup/WarningPopup';
import { getChimeParticipants } from '../../Chime/helpers/get-participants';
import { isPlatform } from '@ionic/react';

interface propsType{
    setShowCreateScheduling: (val: boolean) => void;
    setClickedVideoData: any
    upcomingSessionList: liveSessionListType[];
    singleSessionDetail: singleSessionType | undefined;
    setSingleSessionDetail: (val: singleSessionType|undefined) => void;
    savedSessionsList: getAllSavedSessionsType | undefined;
    setClickedVideoUrl: (val: string) => void;
    setClickedSessionDetails?: any;
    clickedSessionDetails?: singleSessionType | undefined;
    setIsDeleted: (val: boolean) => void;
    fetchUpcomingSessions: any;
    isClickedSessionDetail: boolean;
    setIsClickedSessionDetail: (val: boolean) => void;
    setEditClicked: (val:boolean) => void;
    setIsTeacherButtonClicked : (value: boolean) => void;
    isTeacherButtonClicked : boolean;
    SetIsMoreClick : (val:boolean) => void;
    sessionEnded : boolean;
    handleStartMeeting: any;
    handleJoinMeeting: any;
    fetchSessionDetails : () => void
    setIsStudentButtonClicked : (value: boolean) => void;
    isStudentButtonClicked : boolean;
    isMoreClick : boolean;
    setSessionEnded : (val : boolean) => void;
}

export interface savedSessionType {
  rsId: string;
  savedSessionUrl: string;
  recordSessionType: string;
  createdAt: string;
  sjId: string;
  sessionId: string;
  topic: string;
  videosPlaybacktimesByRsId: {
    nodes: [{
      playbackTime: string;
    }]
  }
}

const SessionsList:FC<propsType> = ({
    setIsClickedSessionDetail, 
    setEditClicked, 
    setClickedVideoData, 
    isClickedSessionDetail, 
    fetchUpcomingSessions, 
    setShowCreateScheduling, 
    setIsDeleted,  
    clickedSessionDetails, 
    setClickedVideoUrl, 
    savedSessionsList, 
    setClickedSessionDetails,  
    upcomingSessionList, 
    setSingleSessionDetail, 
    singleSessionDetail,
    setIsTeacherButtonClicked ,
    isTeacherButtonClicked,
    SetIsMoreClick,
    sessionEnded,
    handleStartMeeting,
    fetchSessionDetails ,
    setIsStudentButtonClicked ,
    isStudentButtonClicked,
    handleJoinMeeting,
    isMoreClick,
    setSessionEnded,
}) => {
  const {MoreIcon, WhiteMoreIcon, calendarSymbol,clockSymbol, sandWatch, videoPlayIcon, DeleteClass, ResetCode, DeleteGif, LiveSessionGif, ScheduleMeeting} = images;
  const baseURL = process.env.REACT_APP_FRONTEND_URL;
  const [isClickedStartButton, setIsClickedStartButton] = useState<boolean>(false);
  const [daysleftValue, setDaysleftValue] = useState('');
  const [startTime, setStartTime] = useState('');
  const [duration, setDuration] = useState('');
  const {success,error} = ToasterWithMessage();
  const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
  const selectedSubjectId = localStorage.getItem('selectedSId');
  const [isOverflow, setIsOverflow] = useState(false);
  const [isDescOverflow,setIsDescOverflow] = useState<boolean[]>([]);
  const descriptionRef = useRef<HTMLDivElement | null>(null);
  const videoDescriptionRef = useRef<(HTMLSpanElement | null)[]>([]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openMenu, setOpenMenu] = useState<boolean>(false);
  const [openConfirmationPopup, setOpenConfirmationPopup] = useState<boolean>(false);
  const navigate = useNavigate();
  const role = useAppSelector((state) => state.auth.role);
  const meetService = useAppSelector((state) => state.auth.meetService)
  const [openWarningPopup, setOpenWarningPopup] = useState<boolean>(false);
  const {localStream, setIsMeetingEndByHost} = useGlobalState();
  const { isMobileScreen } = getScreenDimensions();
  const [warningMessage, setWarningMessage] = useState<string>('');
  const isSafariBrowser = /^((?!chrome|android).)*safari/i.test(navigator.userAgent.toLowerCase());
  const profile = useAppSelector((state) => state?.auth?.adminProfile);
  const [alreadyTwoUsersSameId, setAlreadyTwoUsersSameId] = useState<boolean>(false)
  const currentUserId = profile?.getCurrentUser?.nodes?.[0]?.uId;
  const isJoined = localStorage.getItem("isJoined") || '';

  const [deleteSession] = useMutation(DELETE_SCHEDULED_SESSION, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
      setShowCreateScheduling(false);
      setIsDeleted(true);
      success("Deleted successfully");
    },
    onError: (err) => {
      error(err?.message);
      if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
        setTimeout(() => {
          if(role === STUDENT_ROLE){
             navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH);
          }else{
             navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH);
          }
        }, 2000);
      }
    }
  });
  
  const textRef = useRef<HTMLDivElement | null>(null);
  const [showTooltip, setShowTooltip] = useState<boolean>(false);

  const handleMouseEnter = () => {
    const div = textRef.current;
  
    if (div) {
      const isOverflowing = div.scrollHeight > div.clientHeight;
      setShowTooltip(isOverflowing);
    }
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };



  const getPreviewStream = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true});
      console.log("[Log] stream", stream, stream?.getTracks());
      stream.getTracks().forEach((track) => track.stop());
      return stream;
    } catch (err: any) {
      console.log("[Log] getPreviewStream Error", err);
      let errorMessage = "Unable to access your camera or microphone. Please check your device settings and try again.";
      if (err?.name === "NotAllowedError" || err?.name === "SecurityError") {
        errorMessage = "Permission denied. Please allow camera and microphone access.";
      } else if (err?.name === "NotFoundError" || err?.name === "DevicesNotFoundError") {
        errorMessage = "No camera or microphone found. Please check your device.";
      } else if (err?.name === "NotReadableError" || err?.name === "HardwareAccessError") {
        errorMessage = "Another app is using your camera or microphone. Close the other app and try again.";
      } else if (err?.name === "OverconstrainedError") {
        errorMessage = "Your camera does not support the requested video resolution.";
      }
      setWarningMessage(errorMessage);
      if (role === TEACHER_ROLE) {
        setIsTeacherButtonClicked(false);
      } else if (role === STUDENT_ROLE) {
        setIsStudentButtonClicked(false);
      }
      setOpenWarningPopup(true);
    }
  };

  const handleClickStartButton = async () => {
    setIsTeacherButtonClicked(true);
    if (meetService === JITSI) {
      setIsClickedStartButton(true);
      handleStartMeeting();
    } else {
      const stream = await getPreviewStream();
      if (stream) {
        setIsClickedStartButton(true);
        handleStartMeeting(stream);
      }
    }
  }

  const handleClickJoinButton = async () => {
    if (role === TEACHER_ROLE) {
      setIsTeacherButtonClicked(true);
    } else if (role === STUDENT_ROLE) {
      setIsStudentButtonClicked(true);
    }
    if (meetService === JITSI) {
      handleJoinMeeting();
    } else {
      const stream = await getPreviewStream();
      if (stream) {
        handleJoinMeeting(stream);
      }
    }
  }

  const [getSingleSessionDetail] = useLazyQuery(GET_SESSTION_BY_ID, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: async (data) => {
      const response = data?.getSession || {};
      const meetId = response?.sessionCode;

      if (meetId && meetService !== JITSI) {
        getChimeParticipants(meetId)
          .then((participantsResponse) => {
            const chimeParticipants = participantsResponse?.Attendees?.filter((participant: any) => {
              if (!participant?.ExternalUserId?.includes("aws:MediaPipeline")) {
                return !participant?.ExternalUserId?.includes("aws:MediaPipeline");
              }
            })
            console.log("participantsResponse", participantsResponse, chimeParticipants);
            response.participantscount = chimeParticipants ? chimeParticipants.length : 0;
          })
          .catch(() => {
            response.participantscount = 0;
          })
          .finally(() => {
            console.log("[Log] Participants count:", response.participantscount);
            if (isMoreClick === false) {
              setSingleSessionDetail(response);
            } else {
              setClickedSessionDetails({ ...response, type: "liveclass" });
            }
          });
      } else {
        if (isMoreClick === false) {
          setSingleSessionDetail(response);
        } else {
          setClickedSessionDetails({ ...response, type: "liveclass" });
        }
      }
      setSessionEnded(false);
    },
    onError: (err) => {
      if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
        error(err?.message);
        setTimeout(() => {
          if(role === STUDENT_ROLE){
            navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH);
         }else{
            navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH);
         }
        }, 2000);
      } else if(err?.message === "Session has ended"){
         setSessionEnded(true);
         setTimeout(() => {
          setSingleSessionDetail(undefined);
          fetchUpcomingSessions();
        }, 5000); 
      }else {
        error(err?.message)
      }
    }
  });


  const onYesButtonClick = () => {
    setOpenConfirmationPopup(false);
    deleteSession({
        variables: {
          cId: selectedClassRoomId,
          sjId: selectedSubjectId,
          sId: clickedSessionDetails?.sessionId,
          ...(meetService === JITSI ? { pMeetingType: "JITSI" } : {}),
        }
      })
  }

  const onNoButtonClick = () => {
      setOpenConfirmationPopup(false);
  }


  //set the particular data when click card
  const onClickSingleSession = (cardItem:liveSessionListType) => {
    setIsClickedSessionDetail(true);
    localStorage.setItem("SessionId",cardItem?.sessionId);
    SetIsMoreClick(false);
    if(openMenu === false){
      getSingleSessionDetail({
        variables:{
          input:{
            cId:selectedClassRoomId,
            sjId:selectedSubjectId,
            sId:cardItem?.sessionId
          }
        }
      })
    }
  };



  const onClickMoreIcon = (event: React.MouseEvent<HTMLElement>,item: liveSessionListType) => {
    event.stopPropagation(); // Stop propagation to prevent triggering parent click
    setAnchorEl(event.currentTarget);
    SetIsMoreClick(true);
    getSingleSessionDetail({
      variables:{
        input:{
          cId:selectedClassRoomId,
          sjId:selectedSubjectId,
          sId:item?.sessionId
        }
      }
    })
    // setClickedSessionDetails(item)
    setOpenMenu(true);
  }

  const handleCloseMenu = () => {
    setOpenMenu(false);
  }

  const onClickEditOption = () => {
        setEditClicked(true);
        handleCloseMenu();
        setShowCreateScheduling(true);
  }

  const onClickDeleteScheduleOption = () => {
        handleCloseMenu();
        setOpenConfirmationPopup(true);
  }

//To check the container is overflow
const checkOverflow = () => {
  if (descriptionRef.current) {
    setIsOverflow(descriptionRef.current.scrollHeight > descriptionRef.current.clientHeight);
  }
};

const checkOverflowVideoDescription = (index:number) => {
  if(videoDescriptionRef.current[index]){
    const overflow = (videoDescriptionRef.current[index]!.scrollHeight - 1) > videoDescriptionRef.current[index]!.clientHeight;
    setIsDescOverflow(prev => {
                const newOverflow = [...prev];
                newOverflow[index] = overflow;
                return newOverflow;
    });
  }
}

const handleResize = () => {
  if(savedSessionsList && savedSessionsList?.totalCount > 0){
    savedSessionsList?.nodes.forEach((_, index) => {
      checkOverflowVideoDescription(index);
    });
  }
};

 //To check overflow in resize 
 useEffect(() => {
  if (savedSessionsList?.nodes) {
    savedSessionsList?.nodes.forEach((_, index) => {
          checkOverflowVideoDescription(index); // Check overflow for each classroom name
      });
  }
}, [savedSessionsList]);

const handleClickVideo = (videoItem: savedSessionType) => {
  setClickedVideoUrl(videoItem?.savedSessionUrl ? baseURL + videoItem?.savedSessionUrl : "");
  setClickedVideoData(videoItem);
}

const checkJoinDetails =() => {
 const alreadyJoined = hasUserAlreadyJoined(singleSessionDetail?.participantIds || [], currentUserId);
        console.log(alreadyJoined, "alreadyJoined")
        if(alreadyJoined) {
        setAlreadyTwoUsersSameId(alreadyJoined)
        }
      else{
          setAlreadyTwoUsersSameId(false)
      }
}
 
  useEffect(() => {
    if(singleSessionDetail){
      const daysLeft = calculateDays(singleSessionDetail?.startdate);
      const startTimeFormatted = formatTime(singleSessionDetail?.startdate);
      const durationFormatted = calculateDuration(singleSessionDetail?.startdate, singleSessionDetail?.enddate);

      setDaysleftValue(daysLeft);
      setStartTime(startTimeFormatted);
      setDuration(durationFormatted);
      checkOverflow();
      const interval = setInterval(() => {
        fetchSessionDetails();
        checkJoinDetails()
      }, 10000); // 60000 ms = 1 minute

      return () => clearInterval(interval);
    }
  },[singleSessionDetail])
  

  //To check overflow in resize 
  useEffect(() => {
    setIsMeetingEndByHost(false);
    //To set stop camera and microphone when initial render.
        if(localStream?.getVideoTracks()[0]){
            localStream.getVideoTracks()[0].enabled = false;
        }
        localStream?.getVideoTracks()[0]?.stop();
        if(localStream?.getAudioTracks()[0]){
            localStream.getAudioTracks()[0].enabled = false;
        }
        localStream?.getAudioTracks()[0]?.stop();
        handleResize(); 
        setIsTeacherButtonClicked(false);
        setIsStudentButtonClicked(false);

        window.addEventListener('resize', checkOverflow);
        window.addEventListener('resize',handleResize);

        return () => {
            window.removeEventListener('resize', checkOverflow);
            window.addEventListener('resize',handleResize);
        };
  }, []);
 


const closeWarnPopup = () => {
  setOpenWarningPopup(false);
  setWarningMessage("");
}

const handleLoadedMetadata = (event: React.SyntheticEvent<HTMLVideoElement>) => {
  const videoElement = event.currentTarget;
  videoElement.currentTime = 1.2;
};

  const StudentJoinButtonCondition = (singleSessionDetail?.isSessionStart && !sessionEnded && (singleSessionDetail?.participantscount > 0))

  const isServerUrlReady = !singleSessionDetail?.meetingType || (singleSessionDetail?.meetingType === "JITSI" && singleSessionDetail?.serverUrl);

  useEffect(()=>{
        
    const alreadyJoined = hasUserAlreadyJoined(singleSessionDetail?.participantIds || [], currentUserId);
        console.log(alreadyJoined, "alreadyJoined")
        if(alreadyJoined) {
        setAlreadyTwoUsersSameId(alreadyJoined)
        }
      else{
          setAlreadyTwoUsersSameId(false)
          setIsStudentButtonClicked(false)
      }
    },[singleSessionDetail?.participantIds])

    useEffect(()=>{
      if(sessionEnded) {
      setAlreadyTwoUsersSameId(false)
      }
    },[sessionEnded])

   return (
    <div className='SessionsListMainContainers'>
        {
          (!singleSessionDetail) && (role === TEACHER_ROLE) &&
         (
           getScreenDimensions()?.isMobileScreen ?
             <img src={ ScheduleMeeting } alt='createschedulebutton' className='mobilecreateButtonStyle' onClick={() => setShowCreateScheduling(true)}/>
             :
             <button className='createButtonStyle' onClick={() => setShowCreateScheduling(true)}>
               Create
             </button>)
        }
        <div className='sessionsListContainer'>
          <div 
            className='upcomingSessionMainContainer' 
            style={{
              height: singleSessionDetail ? '245px' : ''
            }}>
              {
                (singleSessionDetail?.sessionId) ?
                <>
                  <div className='singleSessionDetail'>
                    <div className='leftSideSessionDetail'>
                        <div className='sesstionTitle'>SESSION</div>
                        <div className='listOfSessionDetail'>
                          <div className='listsStyle'>
                              <div className='listStyle'>
                                  <div className='imgCtn'>
                                  <img src={calendarSymbol} alt='calendarIcon' className='sideIconStyle'/>
                                  </div>
                                  <div className='textStyle'>{daysleftValue}</div>
                              </div>
                              <div className='listStyle'>
                                  <div className='imgCtn'>
                                  <img src={clockSymbol} alt='clockIcon' className='sideIconStyle'/>
                                  </div>
                                  <div className='textStyle'>{startTime}</div>
                              </div>
                              <div className='listStyle'>
                                  <div className='imgCtn'>
                                  <img src={sandWatch} alt='sandIcon' className='sideIconStyle'/>
                                  </div>
                                  <div className='textStyle'>{duration}</div>
                              </div>
                          </div>
                          <div className='minsSeparationContainer'>
                              <div className='separationStyle'>{singleSessionDetail?.teachingPeriod ? formatPart(convertToMinutes(singleSessionDetail?.teachingPeriod)) : '0 min'}: Teaching</div>
                              <div className='separationStyleDiff'>{singleSessionDetail?.discussionPeriod ? formatPart(convertToMinutes(singleSessionDetail?.discussionPeriod)):'0 min'}: Interactions</div>
                          </div>
                        </div>
                    </div>
                    <div className='rightSideSessionDetail'>
                        <div className='lessonTopicContainer'>
                          <div className='heaaderStyle'>
                            <div className='headTextStyle'>LESSON TOPIC:</div>
                            <Tooltip
                              title={singleSessionDetail?.lessonTopic}
                              open={showTooltip}
                              placement="bottom"
                              disableInteractive
                            >
                              <div
                                ref={textRef}
                                className="ansHeadTextStyle"
                                onMouseEnter={handleMouseEnter}
                                onMouseLeave={handleMouseLeave}
                              >
                                {singleSessionDetail?.lessonTopic}
                              </div>
                            </Tooltip>
                          </div>
                          <Tooltip title={singleSessionDetail?.description} disableHoverListener={!isOverflow}>
                            <div
                              className='descriptionStyle'
                              ref={descriptionRef}
                              onMouseEnter={checkOverflow}
                              >
                              {singleSessionDetail?.description}
                            </div>
                          </Tooltip>
                        </div>
                     { role === STUDENT_ROLE ?
                       <div>
                       <button 
                            className={`${(StudentJoinButtonCondition && !isStudentButtonClicked && !alreadyTwoUsersSameId && ((isJoined === "left" || isJoined === ''))) ? 'sessionJoinButton' : 'notReadyStudentButtonStyle'}`} 
                            onClick={handleClickJoinButton}
                        >
                           {sessionEnded ? `Session Ended` : (singleSessionDetail?.isSessionStart && singleSessionDetail?.participantscount === 0) ? `Session completed` : singleSessionDetail?.isSessionStart ? `Join` : 'Not Ready'}
                       </button>
                       {!singleSessionDetail?.isSessionStart && !sessionEnded && singleSessionDetail?.isActive &&
                        <span className='sessionNotYetStarted'>
                          Host has not yet started the meeting
                        </span>
                       }
                      {alreadyTwoUsersSameId && (
                      <span className='alert-msg'>
                        {ALERT_MESSAGE_TWO_USERS}
                      </span>
                    )}
                      {(!(isJoined === "left" || isJoined === '')) && StudentJoinButtonCondition && !sessionEnded && !alreadyTwoUsersSameId && (
                            <span className='alreadyInMeeting'>
                                {ALERT_MESSAGE_ALREADY_IN_MEETING}
                            </span>
                      )}
                       </div>
                        :
                        <div>
                        <button 
                         className={`${(singleSessionDetail?.isActive && !sessionEnded && !isTeacherButtonClicked && isServerUrlReady && !alreadyTwoUsersSameId && ((isJoined === "left" || isJoined === ''))) ? 'sessionStartButton' : 'notReadyButtonStyle'} ${(singleSessionDetail?.isSessionStart && isServerUrlReady) ? 'sessionStartButton' : ''}`} 
                         onClick={
                          meetService === JITSI ?
                          (singleSessionDetail?.isSessionStart ? handleClickJoinButton : handleClickStartButton)
                          : ((singleSessionDetail?.isSessionStart && singleSessionDetail?.participantscount === 0) ? handleClickStartButton : (singleSessionDetail?.isSessionStart && singleSessionDetail?.participantscount > 0) ? handleClickJoinButton : handleClickStartButton)
                         }
                        > 
                         {
                           sessionEnded ? `Session Ended` : (singleSessionDetail?.isActive && !singleSessionDetail?.isSessionStart && isServerUrlReady) ? `Start` :(singleSessionDetail?.isSessionStart && isServerUrlReady)? 'Join' : 'Not Ready'
                         }
                       </button>
                       {alreadyTwoUsersSameId && (
                        <span className='alert-msg'>
                          {ALERT_MESSAGE_TWO_USERS}
                        </span>
                      )}
                       {(!(isJoined === "left" || isJoined === '')) && singleSessionDetail?.isActive && !sessionEnded && isServerUrlReady && !alreadyTwoUsersSameId && (
                            <span className='alreadyInMeeting'>
                                {ALERT_MESSAGE_ALREADY_IN_MEETING}
                            </span>
                        )}
                       </div>
                     }
                    </div>
                  </div>
                </> :
                upcomingSessionList?.length > 0 ?
                <>
                    <div className='upComingSessionTitle'>Scheduled Sessions</div>
                    <div className='upcomingSessionListContainer'>
                        <div className='cardContainer'>
                          {
                            upcomingSessionList?.map((cardItem: liveSessionListType,index: number) => {
                              const {dayMessage,formattedDate,dayOfWeek} = getFormattedDateInfo(cardItem?.startDate);
                              return (
                                <div className={(cardItem?.isactive && (role === TEACHER_ROLE)) ? "activeSessionForTeacher" : 'upcomingSessionCard'} onClick={() => onClickSingleSession(cardItem)} key={`${index}-${cardItem?.sessionId}`}>
                                      <div className='titleContainer'>
                                        <div className={cardItem?.isactive ? 'activeDotContainer': 'forTeacherStyle'} style={{backgroundColor: ((cardItem?.isactive) && (role === STUDENT_ROLE)) ? '#0B74BB' : '', marginLeft: ((cardItem?.isactive) && (role === STUDENT_ROLE)) ? '25px' : '17px'}}>
                                          {cardItem?.isactive ? <span className='activeDot'></span> : ''}
                                          <div className={(cardItem?.isactive && (role === TEACHER_ROLE)) ? 'activeTitleStyle' : 'titleStyle'} style={{color: (cardItem?.isactive ? 'white' : 'black')}}>{dayMessage}</div>
                                        </div>
                                        {
                                          role !== STUDENT_ROLE && !cardItem?.isSessionStart
                                          ? 
                                          <div className='moreIconContainer' onClick={(e) => onClickMoreIcon(e,cardItem)}>
                                            <img src={cardItem?.isactive ? WhiteMoreIcon : MoreIcon} alt='more' className='moreIconStyle'/>
                                          </div>
                                          : 
                                          <></>
                                        }
                                          
                                      </div>
                                      <div className='dayContainer'>
                                          <div className={(cardItem?.isactive && (role === TEACHER_ROLE)) ? 'activeDayStyle': 'dayStyle'}>{dayOfWeek}</div>
                                          <div className={(cardItem?.isactive && (role === TEACHER_ROLE)) ? 'activeMonthDateStyle' : 'monthDateStyle'}>{formattedDate}</div>
                                      </div>
                                </div>
                                )
                            }
                          )
                          }
                        </div>
                        <Menu
                                id="action-menu"
                                MenuListProps={{
                                    "aria-labelledby": "long-button",
                                    disablePadding: true,
                                }}
                                anchorEl={anchorEl}
                                open={openMenu}
                                onClose={handleCloseMenu}
                                anchorOrigin={{
                                    vertical: 'center',
                                    horizontal: 'left',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                sx={{
                                    '& .MuiPaper-root': {
                                        borderRadius: '5px',
                                        boxShadow: '-10px 10px 15px 0.2px rgba(0, 0, 0, 0.05)',
                                    },
                                }}
                                classes={{
                                  paper: 'menuPaperStyle'
                                }}
                          >
                            <div className='menuitemContainer'>
                                <MenuItem className='menuItemStyle' onClick={onClickEditOption}>
                                    <img src={ResetCode} alt='resetCodeIcon'/>
                                    <p className='labelStyle'>Edit</p>
                                </MenuItem>
                                <MenuItem className='menuItemStyle' onClick = {onClickDeleteScheduleOption}>
                                    <img src={DeleteClass} alt='deleteClassIcon'/>
                                    <p className='labelStyle'>Delete Schedule</p>
                                </MenuItem>
                            </div>
                          </Menu>
                    </div>
                </> 
                :
                <>
                    <div className='noMeetings'>
                        <img alt='gif' src={LiveSessionGif} className='scheduleMeetGifStyle'/>
                        <div className='noMeetingsText'>{`No Meeting Available`}</div>
                        {isMobileScreen && role === TEACHER_ROLE && (
                          <button className='createButtonStyle' onClick={() => setShowCreateScheduling(true)}>
                            Create
                          </button>
                        )}
                    </div>
                </>
                
              }
          </div>
          <div className='savedSessionsMainContainer' style={{height: (singleSessionDetail?.sessionId) ? 'calc(100% - 258px)' : 'calc(100% - 192px)'}}>
              <div className='savedSessionTitle'>Saved Sessions</div>
              <div className='savedSessionListContainer' style={{display: !(savedSessionsList && savedSessionsList?.totalCount > 0) ? 'flex' : ''}}>
                    {
                      savedSessionsList && savedSessionsList?.totalCount > 0 ?

                        ((savedSessionsList) && savedSessionsList?.nodes?.map((videoItem: savedSessionType,index: number) => (
                          <div className='videoContainer' onClick={() => handleClickVideo(videoItem)}>
                              <video src={videoItem?.savedSessionUrl ? `${baseURL}${videoItem?.savedSessionUrl}${isSafariBrowser?'#t=0.001':''}` : ''} muted loop className='videoTagStyle' onCanPlay={(event) => handleLoadedMetadata(event)}/>
                              <div className='descriptionContainer'>
                                  <div className='savedDateStyle'>{formatSavedDate(videoItem?.createdAt)}</div>
                                  <Tooltip title={videoItem?.topic} disableHoverListener={!isDescOverflow[index]}>
                                      <div className='descriptionStyle' onMouseEnter={() => checkOverflowVideoDescription(index)} onMouseMove={() => checkOverflowVideoDescription(index)} ref={(el) => (videoDescriptionRef.current[index] = el)}>
                                        {videoItem?.topic}
                                      </div>
                                  </Tooltip>
                              </div>
                              <img src={videoPlayIcon} className='playIconStyle' alt='videoPlayIcon'/>
                          </div>
                        ))
                      )
                      :
                      <div className='noDataFoundStyle'>
                        {`No data found`}
                      </div>
                    }
              </div>
          </div>
        </div>
        <ConfirmationPopup
          open={openConfirmationPopup}
          message={`Are you sure you want to Delete this session?`}
          gifData={DeleteGif}
          yesButtonFunctionality={onYesButtonClick}
          noButtonFunctionality={onNoButtonClick}
          messageWidth={'195px'}
        />
        <WarningPopup
          message={ warningMessage }
          openWarningPopup={ openWarningPopup }
          closeWarnPopup={ closeWarnPopup }
        />
    </div>
  )
}

export default SessionsList;
